import React from 'react';
import { motion } from 'framer-motion';

const IconWrapper = ({ 
  children, 
  size = 24, 
  variant = 'default',
  glowColor = '#A259FF',
  containerStyle = false,
  animated = true,
  className = '',
  onClick,
  ...props 
}) => {
  const variants = {
    default: {
      base: 'text-white',
      hover: 'text-white',
      glow: 'drop-shadow-[0_0_6px_rgba(255,255,255,0.4)]',
      mobileGlow: 'drop-shadow-[0_0_10px_rgba(255,255,255,0.8)]'
    },
    neon: {
      base: 'text-[#00FFFF]',
      hover: 'text-white',
      glow: 'drop-shadow-[0_0_8px_rgba(0,255,255,0.6)]',
      mobileGlow: 'drop-shadow-[0_0_12px_rgba(0,255,255,0.9)]_drop-shadow-[0_0_6px_rgba(255,255,255,0.7)]'
    },
    purple: {
      base: 'text-[#A259FF]',
      hover: 'text-white',
      glow: 'drop-shadow-[0_0_8px_rgba(162,89,255,0.6)]',
      mobileGlow: 'drop-shadow-[0_0_12px_rgba(162,89,255,0.9)]_drop-shadow-[0_0_6px_rgba(255,255,255,0.7)]'
    },
    gradient: {
      base: 'bg-gradient-to-r from-[#A259FF] to-[#00FFFF] bg-clip-text text-transparent',
      hover: 'from-white to-[#00FFFF]',
      glow: 'drop-shadow-[0_0_10px_rgba(162,89,255,0.8)]',
      mobileGlow: 'drop-shadow-[0_0_14px_rgba(162,89,255,0.9)]_drop-shadow-[0_0_8px_rgba(0,255,255,0.7)]'
    }
  };

  const currentVariant = variants[variant] || variants.default;

  const containerClasses = containerStyle 
    ? 'bg-white/10 backdrop-blur-sm rounded-lg p-2 border border-white/20 md:bg-white/10 md:border-white/20 mobile-icon-container' 
    : '';

  // Mobile-specific icon classes
  const iconClasses = `
    ${currentVariant.base}
    ${containerStyle ? '' : currentVariant.glow}
    transition-all duration-200 ease-in-out
    mobile-icon-enhance
    ${className}
  `;

  const motionProps = animated ? {
    whileHover: { 
      scale: 1.1,
      filter: variant === 'gradient' 
        ? 'drop-shadow(0 0 12px rgba(162,89,255,0.9))' 
        : currentVariant.glow.replace('0.4', '0.8').replace('0.6', '0.9')
    },
    whileTap: { scale: 0.95 },
    transition: { duration: 0.2 },
    // Ensure proper touch target on mobile
    style: { minWidth: '44px', minHeight: '44px' }
  } : {};

  const IconComponent = React.cloneElement(children, {
    size,
    className: iconClasses,
    style: variant === 'gradient' ? {
      background: 'linear-gradient(45deg, #A259FF, #00FFFF)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      strokeWidth: '2.5px',
      ...children.props.style
    } : {
      strokeWidth: window.innerWidth <= 768 ? '2.5px' : '2px',
      ...children.props.style
    }
  });

  return (
    <motion.div 
      className={`inline-flex items-center justify-center ${containerClasses}`}
      onClick={onClick}
      {...motionProps}
      {...props}
    >
      {IconComponent}
    </motion.div>
  );
};

export default IconWrapper; 